// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { type Theme } from '@emotion/react';
import { TooltipPrimitive, type TooltipPrimitiveProps } from '@atlaskit/tooltip';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import type { RefAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HiddenTooltip: StyledComponent<
	Omit<TooltipPrimitiveProps, 'ref'> &
		RefAttributes<HTMLDivElement> & {
			theme?: Theme;
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
		},
	{},
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled(TooltipPrimitive)({
	display: 'none',
});
